import React, { useMemo } from "react";
import styled from "@emotion/styled";
import { buildCssGF } from "../../guesappfuction/guestappfuction";

const ContainerDiv = styled.div`
  height: 0.2rem;
  position: relative;
  z-index: 1;

  ${({ dividercss }) => `
    ${dividercss.dividerhMobile}

    @media (min-width: ${dividercss.breakpoint}px) {
      ${dividercss.dividerDesk}
    }     
  `}
`;

const Shared03Divider = ({ options = {} }) => {
  //Des

  const { obj_divider = {}, style_render } = options || {};

  const compiledStyles = useMemo(
    () => ({
      breakpoint: Number(style_render),

      //divider
      dividerhMobile: buildCssGF(obj_divider?.divider_mobile_styles),
      dividerDesk: buildCssGF(obj_divider?.divider_desktop_styles),
    }),
    // eslint-disable-next-line
    [obj_divider, style_render]
  );

  return (
    <ContainerDiv
      {...(obj_divider?.divider_id && {
        id: obj_divider?.divider_id,
      })}
      className="divider"
      dividercss={compiledStyles}
    />
  );
};

export default Shared03Divider;
